import { render, staticRenderFns } from "./image-cut.vue?vue&type=template&id=f98df122&scoped=true"
import script from "./image-cut.vue?vue&type=script&lang=js"
export * from "./image-cut.vue?vue&type=script&lang=js"
import style0 from "./image-cut.vue?vue&type=style&index=0&id=f98df122&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98df122",
  null
  
)

export default component.exports